<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <Button
      :disabled="disabled"
      :icon="{ left: `user-plus` }"
      @click="show = true"
      >Add User
    </Button>
    <Modal
      :className="$style.modal"
      label="Manage external Discord user"
      v-model="show"
    >
      <form @submit.prevent="submit">
        <Stack direction="column" align="stretch" :class="$style.stack">
          <Input name="First Name" v-model="firstName" label="First Name" placeholder="Test" required />
          <Input name="Last Name" v-model="lastName" label="Last Name" placeholder="Testerson" required />
          <Input name="Email" v-model="email" label="Email" placeholder="test@hackthe6ix.com" required />
          <Input name="Suffix" v-model="suffix" label="Suffix" placeholder="e.g. Hack the 6ix LLC"/>

          <Checkbox
            v-for="role of discordRoles"
            :options="discordRoles"
            v-model="roles[role]"
            :name="role"
            :label="role"
            :key="role"
          />

          <Stack direction="row">
            <Button type="button" @click="showCheckInQr" :icon="{ left: `qrcode` }">Show Check In QR</Button>
            <Button type="button" @click="checkInUser" :icon="{ left: `map-pin` }">Check In</Button>
          </Stack>
          <Stack direction="row">
            <Button
                :icon="{ left: `user-plus` }"
                :loading="loading"
            >
              {{ user ? 'Update' : 'Add User' }}
            </Button>

            <Button
                type="button"
                :icon="{ left: `trash-alt` }"
                @click="deleteUser">
              Delete
            </Button>
          </Stack>
        </Stack>
      </form>
    </Modal>
  </div>
</template>

<script>
  import Button from '@hackthe6ix/vue-ui/Button';
  import Checkbox from '@hackthe6ix/vue-ui/Checkbox';
  import Input from '@hackthe6ix/vue-ui/Input';
  import Modal from '@hackthe6ix/vue-ui/Modal';
  import Select from '@hackthe6ix/vue-ui/Select';
  import Stack from '@hackthe6ix/vue-ui/Stack';
  import swal from 'sweetalert';
  import 'vue-awesome/icons/trash-alt';
  import 'vue-awesome/icons/user-plus';
  import 'vue-awesome/icons/map-pin';
  import {createObject, deleteObject, editObject, getObject, multiCheckInQR} from '../../../../utils/api';
  import { discordRoles } from '../../../../utils/const';
  import {processCheckInUser} from "@/utils/checkInShared";

  export default {
  name: 'ManageExternalUser',
  props: {
    user: Object,
    updateUserCB: Function
  },
  data() {
    return {
      discordRoles,
      loading: false,
      show: false,
      roles: this.initRoles(),
      firstName: '',
      lastName: '',
      suffix: '',
      email: ''
    };
  },
  methods: {
    async deleteUser() {
      const confirm = await swal({
        title: 'Confirm Deletion',
        text:`Are you sure you want to delete this user? (${ this.firstName } ${ this.lastName}; ${ this.email })`,
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      });

      if (confirm) {
        const result = await deleteObject('externaluser', {
          email: this.email.toLowerCase()
        });

        if (result.success) {
          await swal('Success', 'User deleted', 'success');
          window.location.reload();
        } else {
          swal('Error', result.data, 'error');
        }
      }
    },
    async submit() {
      this.loading = true;

      let updatedUser = {
        email: this.email.toLowerCase().trim(),
        firstName: this.firstName.trim(),
        lastName: this.lastName.trim(),
        discord: {
          additionalRoles: Object.keys(this.roles).filter(role => this.roles[role]),
          suffix: this.suffix || undefined
        }
      };

      if (this.user) {
        // Update

        const result = await editObject('externaluser', {
          _id: this.user._id
        }, updatedUser);
        if (result.success) {
          swal('Success', 'User has been updated', 'success');
        } else {
          swal('Error', result.data, 'error');
        }

      } else {
        // Create

        // Verify no other user has this email
        const checkDuplicateResult = await getObject('externaluser', {
          filter: {
            email: this.email.toLowerCase()
          }
        });
        if (checkDuplicateResult.success) {
          if (checkDuplicateResult.data.length > 0) {
            swal('Unable to add user', 'It looks like this email is already registered', 'error');
            return;
          }
        } else {
          swal('Error', checkDuplicateResult.data, 'error');
        }

        // Go ahead and make the new object
        const createUserResult = await createObject('externaluser', updatedUser);
        if (createUserResult.success) {
          swal('Success', 'User has been added to the system', 'success');
        } else {
          swal('Error', createUserResult.data, 'error');
        }
      }

      if (this.updateUserCB) {
        this.updateUserCB({
          ...this.user,
          ...updatedUser
        });
      }

      this.loading = false;
      this.show = false;
    },
    initRoles() {
      return discordRoles.reduce((accumulator, role) => {
        const out = {};

        out[role] = false;

        return {
          ...accumulator,
          ...out
        }
      }, {})
    },
    updateLocalUser(user) {
      this.roles = user.discord.additionalRoles.reduce((accumulator, role) => {
        const out = {
          ...accumulator
        };

        out[role] = true;

        return out;
      }, this.initRoles()) || this.initRoles();

      this.firstName = user.firstName || '';
      this.lastName = user.lastName || '';
      this.suffix = user.discord.suffix || '';
      this.email = user.email.toLowerCase() || ''
    },
    async showCheckInQr() {
      const qrCodeInfo = await multiCheckInQR([{
        userID: this.user._id,
        userType: "ExternalUser"
      }]);

      const wrapper = document.createElement('div');
      const qrImage = document.createElement('img');
      qrImage.src = qrCodeInfo.data[0].code;

      wrapper.appendChild(qrImage);

      swal({
        text: "Successfully generated QR code",
        content: wrapper,
      })
    },
    checkInUser() {
      processCheckInUser(this.user, "ExternalUser");
    }
  },
  components: {
    Input,
    Button,
    Select,
    Stack,
    Modal,
    Checkbox
  },
  watch: {
    show(s) {
      if (!s) {
        this.updateUserCB(null);
      }

      this.updateLocalUser(this.user || {
        discord: {}
      });
    },
    user(u) {
      if (u) {
        this.show = true;
      }
    }
  }
};
</script>

<style lang="scss" module src="./ManageExternalUser.scss" />
